<template>
  <section class="v parking-lot-detail">
    <v-layout row wrap fill-height>
      <v-flex xs12 :md6="!createMode" :lg8="!createMode" :md12="createMode" :lg12="createMode">
        <v-card class="map" :class="{'update-shape-mode': updateShapeMode}">
          <mapbox
            :access-token="mapSettings.accessToken"
            :map-style="mapSettings.style"
            :center="center"
            :zoom="mapSettings.zoom"
            :layer="layer"
            :marker="marker"
            @load="onMapLoaded"
            ref="mapbox"
            :set-drag-marker="showDragMarker()"
            :set-drag-marker-coords="center"
            @zoom="onMapZoom"
            @layer-click="onLayerClick"
            @marker-click="onMarkerClick"
            @marker-set="onMarkerSet"
            @draw="onMapDraw"
            :draw-mode="drawMode"
            v-if="parkingLotData.center && showMap"
          ></mapbox>
          <div class="map-backdrop" @click="setShapeUpdate(false)"></div>
          <div class="shape-update-elements" v-show="updateShapeMode">
            <v-snackbar
              v-model="updateShapeMode"
              bottom
              left
              multi-line
              :timeout="0"
            >
              Nutze das Zeichentool oben rechts um ein neues Feld einzuzeichnen
              , mit dem das alte überschrieben werden soll.
            </v-snackbar>
            <div class="right">
              <v-btn color="blue-grey" @click="setShapeUpdate(false)" dark>Abbrechen</v-btn>
              <v-btn color="primary" @click="updateShape" :disabled="creationGeoJson === null">
                Speichern
              </v-btn>
            </div>
          </div>
        </v-card>
        <parking-lot-creation
          ref="parkingLotCreation"
          :geo-json="creationGeoJson"
          missing-devices
          :device-folder="false"
          :hint="false"
          :has-name="true"
          create-mode="marker"
          @close="onParkingSpaceCreationClosed"
          @save="onParkingSpaceCreationSaved"
        >
          <template name="additional-fields">
            <v-flex xs12>
              <v-select
                v-model="creation.type"
                :items="creation.types"
                item-text="name"
                item-value="id"
                label="Typ*"
                required
              ></v-select>
            </v-flex>
          </template>
        </parking-lot-creation>
      </v-flex>
      <transition name="fadeDash">
        <v-flex xs12 md6 lg4 class="parking-space-list-wrapper" v-show="!createMode">
          <v-btn round large color="primary" @click="openParkingSpaceCreation">
            <v-icon left>add</v-icon>
            Parkplatz hinzufügen
          </v-btn>
          <parking-space-list
            :data="parkingSpaces"
            show-index
            :link="false"
            :parking-lot-list="false"
            two-line
            @item-click="onListItemClicked">
          </parking-space-list>
        </v-flex>
      </transition>
    </v-layout>
    <parking-lot-settings
      @close="onSettingsClose"
      @update-parking-lot-shape="onParkingLotShapeUpdate"
      ref="settings">
    </parking-lot-settings>
    <parking-space-detail
      :data="parkingSpaceDetailData"
      ref="parkingSpaceDetail"
      @delete="onParkingSpaceDelete"
      @parking-space-shape-update="onParkingSpaceShapeUpdate"></parking-space-detail>
  </section>
</template>

<script>
import * as turf from '@turf/turf';
import loadingHandler from '../../services/loadingHandler';
import Mapbox from '../components/Mapbox.vue';
import ParkingSpaceList from '../components/ParkingLot/ParkingLotList.vue';
import ParkingLotSettings from '../components/ParkingLot/ParkingLotSettings.vue';
import ParkingLotCreation from '../components/ParkingLot/ParkingLotCreation.vue';
import ParkingSpaceDetail from '../components/ParkingLot/ParkingSpaceDetail.vue';

export default {
  name: 'Home',

  components: {
    Mapbox,
    ParkingSpaceList,
    ParkingLotSettings,
    ParkingLotCreation,
    ParkingSpaceDetail,
  },

  data() {
    return {
      dialog: false,
      mapSettings: {
        center: [10.014791, 53.548523],
        zoom: 19,
        accessToken: this.$variables.mapbox.accessToken,
        style: this.$variables.mapbox.defaultOptions.style,
      },
      createMode: false,
      updateShapeMode: false,
      updateParkingSpaceId: null,
      drawMode: false,
      creationGeoJson: null,
      showMap: true,
      creation: {
        type: '',
        types: [
          { name: 'Parkplatz für E-Autos', id: 'charging' },
          { name: 'Behindertenparkplatz', id: 'handicapped' },
          { name: 'Parkplatz', id: 'normal' },
          { name: 'Eltern-Kind-Parkplatz', id: 'woman' },
        ],
      },
      layer: [],
      marker: [],
      parkingSpaceDetailData: {},
    };
  },

  watch: {
    $route(to, from) {
      this.checkRoute(to);
    },
    updateParkingSpaceViaSocket(newVal) {
      if (newVal === -1) {
        this.showMap = false;
        this.setMarker();
        setTimeout(() => {
          this.showMap = true;
        }, 50);
      }
    },
  },

  computed: {
    parkingLotData() {
      this.$store.navigation.commit('SET_NAV_TITLE', this.$store.parkingLots.state.parkingLotDetail.name);
      return this.$store.parkingLots.state.parkingLotDetail;
    },
    parkingSpaces() {
      this.layer = [];
      if (this.$store.parkingLots.state.parkingLotDetail.parking_spaces) {
        // this.$store.parkingLots.state.parkingLotDetail.parking_spaces.map((parkingSpace) => {
        //   // this.layer.push(parkingSpace.layer);
        // });
        this.layer.push(this.$store.parkingLots.state.parkingLotDetail.layer);
        this.setMarker();
      }
      return this.$store.parkingLots.state.parkingLotDetail.parking_spaces;
    },
    center() {
      return this.$store.parkingLots.state.parkingLotDetail.center.geoJson.geometry.coordinates;
    },
    updateParkingSpaceViaSocket() {
      return this.$store.parkingLots.state.updateParkingSpaceViaSocket;
    },
  },

  methods: {
    onMapLoaded() {
      const bbox = turf.bbox(this.parkingLotData.shape);
      this.$refs.mapbox.map.fitBounds(bbox, { padding: 24 });
    },
    checkRoute(route) {
      if (route.params.mode === 'settings') {
        this.showSettings(true);
      } else {
        this.showSettings(false);
      }
    },
    showSettings(bool) {
      this.$refs.settings.toggle(bool);
    },
    showDragMarker() {
      return this.createMode && !this.drawMode
    },
    onSettingsClose() {
      this.$router.push(`/parking_lot/${this.$route.params.id}`);
    },
    openParkingSpaceCreation() {
      this.$store.devices.dispatch('GET_DEVICES', this.$route.params.id);
      this.createMode = true;
      this.$refs.parkingLotCreation.toggle();
      setTimeout(() => {
        this.$refs.mapbox.map.resize();
      }, 350);
    },
    onParkingSpaceCreationClosed() {
      this.createMode = false;
      this.creation.type = '';
      setTimeout(() => {
        this.$refs.mapbox.map.resize();
      }, 500);
    },
    onMapDraw(e) {
      if (e.type === 'draw.create' || e.type === 'draw.update') {
        this.creationGeoJson = e.features[0].geometry;
      } else {
        this.creationGeoJson = null;
      }
    },
    onMapZoom(e) {
      const zoom = e.getZoom();
      if (zoom < 19.45) {
        this.marker.map((marker, index) => {
          const el = this.$el.querySelector(`#marker-${marker.id}`);
          el.classList.add('mini-marker');
        });
      } else {
        this.marker.map((marker, index) => {
          const el = this.$el.querySelector(`#marker-${marker.id}`);
          el.classList.remove('mini-marker');
        });
      }
    },
    setMarker() {
      this.marker = [];
      if (this.$store.parkingLots.state.parkingLotDetail.parking_spaces !== undefined) {
        this.$store.parkingLots.state.parkingLotDetail.parking_spaces.map((parkingSpace) => {
          if (parkingSpace.center) {
            this.marker.push(parkingSpace.center);
          }
        });
      }
    },
    onParkingSpaceCreationSaved(args) {
      this.$store.parkingLots.dispatch('POST_PARKING_SPACE', {
        shape: args.shape,
        name: args.name,
        type: this.creation.type,
        sensor_model: 'bosch',
        device_id: args.device_id,
        parking_lot_id: this.parkingLotData.id,
      });
    },
    onListItemClicked(parkingSpace) {
      this.parkingSpaceDetailData = parkingSpace;
      this.$refs.parkingSpaceDetail.toggle();
    },
    onParkingSpaceDelete(id) {
      this.$refs.mapbox.map.removeLayer(`layer-space-${id}`);
    },
    onLayerClick(e) {
      const id = e.id.split('layer-space-');
      if (!this.createMode) {
        this.parkingSpaces.map((parkingSpace) => {
          if (parkingSpace.id === id[1] && !this.updateShapeMode) {
            this.parkingSpaceDetailData = parkingSpace;
            this.$refs.parkingSpaceDetail.toggle();
          }
        });
      }
    },
    onMarkerClick(id) {
      if (!this.createMode) {
        this.parkingSpaces.map((parkingSpace) => {
          if (parkingSpace.id === id && !this.updateShapeMode) {
            this.parkingSpaceDetailData = parkingSpace;
            this.$refs.parkingSpaceDetail.toggle();
          }
        });
      }
    },
    onMarkerSet(coords) {
      console.log('event', coords);
      this.creationGeoJson = {
        type: 'Point',
        coordinates: [coords.lng, coords.lat],
      };
    },
    setShapeUpdate(bool) {
      const bbox = turf.bbox(this.parkingLotData.shape);
      this.createMode = bool;
      this.updateShapeMode = bool;
      this.drawMode = bool;
      this.$refs.parkingSpaceDetail.setPersistentOfDialog(bool);
      setTimeout(() => {
        this.$refs.mapbox.map.resize();
      }, 350);
      setTimeout(() => {
        this.$refs.mapbox.map.fitBounds(bbox, { padding: 24 });
      }, 500);
    },
    onParkingSpaceShapeUpdate(id) {
      this.createMode = true;
      this.updateShapeMode = true;
      this.drawMode = false;
      this.updateParkingSpaceId = id;
      setTimeout(() => {
        this.$refs.mapbox.map.resize();
      }, 350);
    },
    onParkingLotShapeUpdate() {
      this.setShapeUpdate(true);
    },
    updateShape() {
      if (this.updateParkingSpaceId !== null) {
        this.$store.parkingLots.dispatch('UPDATE_PARKING_SPACE', {
          parkingLotId: this.$route.params.id,
          parkingSpaceId: this.updateParkingSpaceId,
          payload: {
            shape: this.creationGeoJson,
          },
        })
          .then(() => {
            this.updateParkingSpaceId = null;
            this.createMode = false;
            this.updateShapeMode = false;
            this.$refs.parkingSpaceDetail.setPersistentOfDialog(false);
            this.showMap = false;
            this.$refs.mapbox.isLoading = true;
            setTimeout(() => {
              this.showMap = true;
            }, 500);
            setTimeout(() => {
              this.$refs.mapbox.map.resize();
              this.$refs.mapbox.isLoading = false;
              this.$store.parkingLots.dispatch('GET_PARKING_SPACES_OF_PARKING_LOT', this.$route.params.id);
            }, 750);
          });
      } else {
        this.$store.parkingLots.dispatch('PATCH_PARKING_LOT_BY_ID', {
          id: this.$route.params.id,
          payload: {
            shape: this.creationGeoJson,
          },
        })
          .then(() => {
            this.createMode = false;
            this.updateShapeMode = false;
            this.showMap = false;
            this.$refs.mapbox.isLoading = true;
            this.showSettings(false);
            setTimeout(() => {
              this.showMap = true;
            }, 500);
            setTimeout(() => {
              this.$refs.mapbox.map.resize();
              this.$refs.mapbox.isLoading = false;
              this.$store.parkingLots.dispatch('GET_PARKING_LOT_BY_ID', this.$route.params.id)
                .then(() => {
                  this.$store.parkingLots.dispatch('GET_PARKING_SPACES_OF_PARKING_LOT', this.$route.params.id);
                });
            }, 750);
          });
      }
    },
  },

  mounted() {
    loadingHandler.setLoading(true);
    this.$refs.settings.toggle(true);
    this.$store.navigation.commit('SET_NAV_BACK_URL', '/');
    this.$store.parkingLots.dispatch('GET_PARKING_LOT_BY_ID', this.$route.params.id)
      .then(() => {
        this.$store.parkingLots.dispatch('GET_PARKING_SPACES_OF_PARKING_LOT', this.$route.params.id);
      });
    this.$store.navigation.commit('SET_NAV_RIGHT_ELEMENTS', [{
      label: 'Einstellungen',
      to: `/parking_lot/${this.$route.params.id}/settings`,
      flat: true,
      color: 'primary',
      icon: {
        show: false,
      },
    }]);
    // this.$store.navigation.commit('SET_TABS', [
    //   { label: 'Karte', to: `/parking_lot/${this.$route.params.id}` },
    //   { label: 'Metriken', to: `/parking_lot_metrics/${this.$route.params.id}` },
    // ]);
    this.$store.navigation.commit('SET_TABS', null);
    this.$store.parkingLots.dispatch('PARKING_LOT_SOCKET', this.$route.params.id);
    this.checkRoute(this.$route);
  },
};
</script>

<style scoped>
.fadeDash-enter-active, .fadeDash-leave-active {
  transition: transform 300ms;
  position: fixed;
  right: 0;
  width: 33.333%;
}
.fadeDash-enter, .fadeDash-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
  position: fixed;
  right: 0;
}
</style>
